module.exports = __webpack_public_path__ + "static/img/8.0411f1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/eng/8.png
// module id = Wnzs
// module chunks = 0